import axios, {AxiosResponse} from "axios";

export class DigitalSolutionsApi {
    public static instance: DigitalSolutionsApi;
    private BASE_URL: string = `${_mgnl.contextPath}/.rest/delivery/digitalsolutions`;
    private VERSION: string = 'v1'
    private constructor() {}

    public static getInstance(): DigitalSolutionsApi {
        if(!this.instance) {
            this.instance = new DigitalSolutionsApi();
        }

        return this.instance;
    }

    /**
     * GetDigitalSolutions
     * @param limit Limits the results
     * @param lang Sets the language for the results
     */
    getDigitalSolutions(limit?: number, lang?: string) : Promise<AxiosResponse> {
        const params = new URLSearchParams();
        if (limit) {
            params.set('limit', String(limit));
        }

        lang ? params.set('lang', lang) : params.set('lang', _mgnl.language);

        return axios.get(`${this.BASE_URL}/${this.VERSION}?${params}`).then((response: AxiosResponse) => {
            return Promise.resolve(response);
        }).catch((err) => {
            return Promise.reject(`Could not fetch the digital solutions. Error: ${err}`);
        })
    }

    /**
     * GetDigitalSolutionsByAreaOfExpertise
     * @param areaOfExpertise UUID of area of expertise to filter through
     * @param limit Limits the results
     * @param lang Sets the language for the results
     */
    getDigitalSolutionsByAreaOfExpertise(areaOfExpertise: string, limit?: number, lang?: string) : Promise<AxiosResponse> {
        const params = new URLSearchParams();
        params.set('areaOfExpertise', areaOfExpertise);

        if (limit) {
            params.set('limit', String(limit));
        }

        lang ? params.set('lang', lang) : params.set('lang', _mgnl.language);

        return axios.get(`${this.BASE_URL}/${this.VERSION}?${params}`).then((response: AxiosResponse) => {
            return Promise.resolve(response);
        }).catch((err) => {
            return Promise.reject(`Could not fetch the digital solutions. Error: ${err}`);
        })
    }

    /**
     * GetDigitalSolution
     * @param uuid The UUID of the Digital Solution
     * @param lang Sets the language for the results
     */
    getDigitalSolution(uuid: string, lang?: string): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        params.set('@jcr:uuid',uuid);
        lang ? params.set('lang', lang) : params.set('lang', _mgnl.language);

        return axios.get(`${this.BASE_URL}/${this.VERSION}?${params}`).then((response: AxiosResponse) => {
            return Promise.resolve(response);
        }).catch((err) => {
            return Promise.reject(`Could not fetch digital solution for uuid: ${uuid}. Error: ${err}`);
        })
    }

    /**
     * GetProjectPhases
     * @param limit Limits the results
     * @param lang Sets the language for the results
     */
    getProjectPhases(limit?: number, lang?: string): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        if (limit) {
            params.set('limit',String(limit));
        }

        lang ? params.set('lang', lang) : params.set('lang', _mgnl.language);

        return axios.get(`${this.BASE_URL}/projectphases/${this.VERSION}?${params}`).then((response: AxiosResponse) => {
            return Promise.resolve(response);
        }).catch((err) => {
            return Promise.reject(`Could not fetch the project phases. Error: ${err}`);
        })
    }

    /**
     * GetProjectPhase
     * @param uuid The UUID of the Project Phase
     * @param lang Sets the language for the results
     */
    getProjectPhase(uuid: string, lang?: string): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        params.set('@jcr:uuid',uuid);
        lang ? params.set('lang', lang) : params.set('lang', _mgnl.language);

        return axios.get(`${this.BASE_URL}/projectphases/${this.VERSION}?${params}`).then((response: AxiosResponse) => {
            return Promise.resolve(response);
        }).catch((err) => {
            return Promise.reject(`Could not fetch the project phase for uuid: ${uuid}. Error: ${err}`);
        })
    }

    /**
     * GetAreasOfExpertise
     * @param limit Limits the results
     * @param lang Sets the language for the results
     */
    getAreasOfExpertise(limit?: number, lang?: string): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        if (limit) {
            params.set('limit', String(limit));
        }

        lang ? params.set('lang', lang) : params.set('lang', _mgnl.language);

        return axios.get(`${this.BASE_URL}/areaofexpertise/${this.VERSION}?${params}`).then((response: AxiosResponse) => {
            return Promise.resolve(response);
        }).catch((err) => {
            return Promise.reject(`Could not fetch areas of expertise. Error: ${err}`);
        })
    }

    /**
     * GetAreaOfExpertise
     * @param uuid The UUID of the Area of Expertise
     * @param lang Sets the language for the results
     */
    getAreaOfExpertise(uuid: string, lang?: string): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        params.set('@jcr:uuid', uuid);

        lang ? params.set('lang', lang) : params.set('lang', _mgnl.language);

        return axios.get(`${this.BASE_URL}/areaofexpertise/${this.VERSION}?${params}`).then((response: AxiosResponse) => {
            return Promise.resolve(response);
        }).catch((err) => {
            return Promise.reject(`Could not fetch area of expertise for uuid: ${uuid}. Error: ${err}`);
        })
    }
}